module.exports = __webpack_public_path__ + "media/YEAH_Scribble_Kopf_Lea_480x480.059000a2.mp4";